function initUtilityBars(scope) {
  var bars = (scope || document).querySelectorAll('[data-utility-bar]');

  bars.forEach(function (bar) {
    if (bar.dataset.utilityInit === 'true') return;
    bar.dataset.utilityInit = 'true';

    var track = bar.querySelector('[data-utility-track]');
    if (!track) return;

    // Mouse drag-to-scroll (touch already works natively via overflow-x + touch scrolling)
    var isDown = false;
    var startX = 0;
    var scrollLeftStart = 0;

    track.addEventListener('mousedown', function (e) {
      if (!bar.classList.contains('utility-bar--mobile-scroll')) return;
      if (track.scrollWidth <= track.clientWidth) return;
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.pageX - track.offsetLeft;
      scrollLeftStart = track.scrollLeft;
    });

    ['mouseleave', 'mouseup'].forEach(function (evt) {
      track.addEventListener(evt, function () {
        isDown = false;
        track.classList.remove('is-dragging');
      });
    });

    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      var walk = x - startX;
      track.scrollLeft = scrollLeftStart - walk;
    });

    // Keyboard support when the track itself is focused
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function (e) {
      if (track.scrollWidth <= track.clientWidth) return;
      if (e.key === 'ArrowRight') {
        track.scrollBy({ left: 80, behavior: 'smooth' });
      } else if (e.key === 'ArrowLeft') {
        track.scrollBy({ left: -80, behavior: 'smooth' });
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initUtilityBars(document);
});

document.addEventListener('shopify:section:load', function (event) {
  var bar = event.target.querySelector('[data-utility-bar]');
  if (bar) bar.dataset.utilityInit = '';
  initUtilityBars(event.target);
});